import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import a1 from '../../img/CompositeMesh/a1.webp';
import a2 from '../../img/CompositeMesh/a2.webp';
import a3 from '../../img/CompositeMesh/a3.webp';
import a4 from '../../img/CompositeMesh/a4.webp';
import a5 from '../../img/CompositeMesh/a5.webp';
import a6 from '../../img/CompositeMesh/a6.webp';
import a7 from '../../img/CompositeMesh/a7.webp';

function AreasApplicationComposite () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
                        <Trans>{t("compositemesh.add.11")}</Trans>
                    </p>
                </div>
                <div className='flex flex-col xl:flex-row justify-between xl:h-[183px] mt-[30px] xl:mt-[70px] gap-y-[20px]'>
                    <div className='relative'>
                        <img src={a1} className='object-cover w-full h-[183px] xl:h-auto' alt="" />
                        <p className='absolute bottom-[15px] left-[15px] open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'><Trans>{t('compositemesh.add.12')}</Trans></p>
                    </div>
                    <div className='relative'>
                        <img src={a2} className='object-cover w-full h-[183px] xl:h-auto' alt="" />
                        <p className='absolute bottom-[15px] left-[15px] open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'><Trans>{t('compositemesh.add.13')}</Trans></p>
                    </div>
                    <div className='relative'>
                        <img src={a3} className='object-cover w-full h-[183px] xl:h-auto' alt="" />
                        <p className='absolute bottom-[15px] left-[15px] open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'><Trans>{t('compositemesh.add.14')}</Trans></p>
                    </div>
                </div>
                <div className='flex flex-col xl:flex-row justify-between xl:h-[183px] mt-[20px] xl:mt-[35px] gap-y-[20px]'>
                    <div className='relative'>
                        <img src={a4} className='object-cover w-full h-[183px] xl:h-auto' alt="" />
                        <p className='absolute bottom-[15px] left-[15px] open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'><Trans>{t('compositemesh.add.15')}</Trans></p>
                    </div>
                    <div className='relative'>
                        <img src={a5} className='object-cover w-full h-[183px] xl:h-auto' alt="" />
                        <p className='absolute bottom-[15px] left-[15px] open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'><Trans>{t('compositemesh.add.16')}</Trans></p>
                    </div>
                    <div className='relative'>
                        <img src={a6} className='object-cover w-full h-[183px] xl:h-auto' alt="" />
                        <p className='absolute bottom-[15px] left-[15px] open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'><Trans>{t('compositemesh.add.17')}</Trans></p>
                    </div>
                    <div className='relative'>
                        <img src={a7} className='object-cover w-full h-[183px] xl:h-auto' alt="" />
                        <p className='absolute bottom-[15px] left-[15px] open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'><Trans>{t('compositemesh.add.18')}</Trans></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AreasApplicationComposite;